import React from 'react';
import type { ChildrenProp } from '../common-types';

/**
 * Props for a {@link WorklineContainer} component.
 */
export type WorklineContainerProps = ChildrenProp;

export function WorklineContainer({
  children,
  ...props
}: Readonly<WorklineContainerProps>): JSX.Element {
  return (
    <div {...props} className="ehs-worklineContainer">
      {children}
    </div>
  );
}
